import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import './Clock.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Clock extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      },
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div className="clock-header">
          <NavigationChevronLeft className="clock-back" />
          <div className="clock-header-text"
            style={styles.primaryFont}>
            Alarm Clock
          </div>
          <div className="clock-action-link"
            style={styles.primaryFont}>
            Set
          </div>
          <div className="clear"></div>
        </div>
        <div className="clock-body">
          <table className="alarm-clock-table"
            style={styles.primaryFont}>
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td>11</td>
                <td>57</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>12</td>
                <td>58</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>1</td>
                <td>59</td>
              </tr>
              <tr className="alarm-set-row">
                <td>AM</td>
                <td>2</td>
                <td>00</td>
              </tr>
              <tr>
                <td>PM</td>
                <td>3</td>
                <td>01</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>4</td>
                <td>02</td>
              </tr>
            </tbody>
          </table>
          <div className="clock-action">
            <div className="clock-action-name"
              style={styles.primaryFont}>
              Repeat
            </div>
            <div className="clock-action-option"
              style={styles.secondaryFont}>
              Once
              <NavigationChevronRight className="clock-action-option-chevron" />
            </div>
          </div>
          <div className="clock-action">
            <div className="clock-action-name"
              style={styles.primaryFont}>
              Sound
            </div>
            <div className="clock-action-option"
              style={styles.secondaryFont}>
              Marimba
              <NavigationChevronRight className="clock-action-option-chevron" />
            </div>
          </div>
        </div>
      </Paper>
    )
  }
}

export default Clock = connect(mapStateToProps, undefined)(Clock);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Clock.jsx